<template>
  <div v-if="pppDiscount < newsletterDiscount && holidayDiscount < newsletterDiscount" id="script-placeholder"></div>
</template>

<script>
import * as Constants from '@/libs/constants'

export default {
  mounted () {
    const script = document.createElement('script')
    script.async = true
    script.dataset.uid = 'e48eee6818'
    script.src = 'https://theburningmonk.ck.page/e48eee6818/index.js'

    const placeholder = document.getElementById('script-placeholder')
    if (placeholder) {
      placeholder.appendChild(script)
    }
  },
  data () {
    return {
      pppDiscount: 0,
      holidayDiscount: 0,
      newsletterDiscount: Constants.NEWSLETTER_DISCOUNT
    }
  },
  methods: {
    handlePppDiscount (amount) {
      this.pppDiscount = amount
    },

    handleHolidayDiscount (amount) {
      this.holidayDiscount = amount
    }
  }
}
</script>
